var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ErrorMessage"},[_c('warning-icon',{staticClass:"ErrorMessage-icon"}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }